import deepmerge from 'deepmerge'
import { ACTION_TYPES } from '~/core/constants'

const { RECENTS } = ACTION_TYPES
const initialState = {
  fetchingInProgress: false,
  sharingUpdateInProgress: false,
  hasMore: true,
  nextPageStartId: null,
  map: {},
  playingRecordingUrl: null
}

const overwriteMerge = (destinationArray, sourceArray) => sourceArray

const reducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case RECENTS.FETCHING_IN_PROGRESS: {
      return {
        ...state,
        fetchingInProgress: payload
      }
    }
    case RECENTS.HAS_MORE_RECENTS: {
      return {
        ...state,
        hasMore: payload
      }
    }
    case RECENTS.NEXT_PAGE_START_ID: {
      return {
        ...state,
        nextPageStartId: payload
      }
    }
    case RECENTS.FETCHED_RECENTS: {
      return {
        ...state,
        fetchingInProgress: false,
        map: deepmerge(state.map, payload, { arrayMerge: overwriteMerge })
      }
    }
    case RECENTS.SET_SUMMARY_FEEDBACK_SUBMITTED: {
      const { sessionId } = payload

      return {
        ...state,
        map: deepmerge(state.map, {
          [sessionId]: {
            summarySubmitted: true
          }
        })
      }
    }
    case RECENTS.SET_PLAYING_RECORDING: {
      return {
        ...state,
        playingRecording: action.payload
      }
    }
    case RECENTS.UPDATE_SHARING_STATUS: {
      return {
        ...state,
        map: deepmerge(state.map, payload, { arrayMerge: overwriteMerge })
      }
    }
    case RECENTS.TOGGLE_SHARING_UPDATE: {
      return {
        ...state,
        sharingUpdateInProgress: action.payload
      }
    }
    default:
      return state
  }
}

export default reducer
